import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ensureDefined, } from '@tymia/shared';
import { createContext, use, useEffect, useState, } from 'react';
import { api, } from './api/Api.js';
const ConfigContext = createContext({});
export function ConfigProvider({ children, }) {
    const [language, setLanguage] = useState('de');
    const [metadata, setMetadata] = useState();
    useEffect(() => {
        async function loadConfig() {
            const response = await api.common.config.request({
                language,
            });
            if (response.status === 'ok') {
                const collator = new Intl.Collator(language);
                setMetadata({
                    ...response,
                    languages: ensureDefined(response.languages).sort((a, b) => collator.compare(a.display, b.display)),
                    getLanguage: () => language,
                    setLanguage,
                    collator,
                });
                return;
            }
            setMetadata(response);
        }
        void loadConfig();
    }, [language]);
    if (!metadata) {
        return _jsx(_Fragment, {});
    }
    if (metadata.status !== 'ok') {
        return _jsx("div", { children: "Fehler beim Laden von Metadaten. Bitte die Seite aktualisieren." });
    }
    return (_jsx(ConfigContext.Provider, { value: metadata, children: children }));
}
export function useConfig() {
    return use(ConfigContext);
}
//# sourceMappingURL=ConfigContext.js.map